#import "../fragments/form-for-landing-page.graphql"

query GetFormsForLandingPages($search: String, $sort: FormSortType!) {
    forms(first: 100, sort: $sort, search: $search, archived: false) {
        edges {
            node {
                ...FormForLandingPage
            }
        }
    }
}
